export default __webpack_public_path__ + "static/oficina-d352bad1f911c13dc6ac7dca3f8d040c.jpg";